import { RouteRecordRaw } from 'vue-router'

const CalendarPage = () =>
  import(/* webpackChunkName: "calendar-view" */ './pages/CalendarPage.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'calendario',
    name: 'calendar',
    component: CalendarPage,
    meta: {
      title: 'Calendario',
      auth: {
        requiredPermission: 'calendar.view',
        requiredModule: 'calendar',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
